angular.module("ainapp")
    .controller("costLedgerController", ["app.config", "$scope", "$http", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window", function (config, $scope, $http, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

        $scope.init = function () {

            $scope.selectAllAccRows = false;
            $scope.Load = false;
            $scope.Error = 0;
            $scope.FromDateObject = null;
            $scope.ToDateObject = null;

            $scope.date1 = new Date();
            var n = $scope.date1.getFullYear();
            $scope.d2 = new Date("01/01/" + n);

            $scope.filter = {
                AccountMasterId: "",
                FromDate: $scope.d2,
                ToDate: new Date(),
                IsFilter: false,
                DocNo: "",
                CostCenter1Id: "",
                CostCenter2Id: "",
                CostCenter3Id: "",
            }

            $scope.finyear = {};
            MainService.getCurrentFinancialYear().then(function (response) {
                $scope.finyear = response.data;
                $scope.filter.FromDate = new Date($scope.finyear.StartDate);
            });

            $scope.CostCenters = [];
            MainService.CostCentersInTreeList().then(function (response) {
                $scope.CostCenters = response.data;
                $scope.SelectedCosts = response.data[0];
            });

            $scope.AccFilter = {
                Keyword: "",
            }
            $scope.selectAll = false;

            $scope.GlLoad = false;
            $scope.AccLoad = true;
            $scope.Accounts = [];
            MainService.AccountList().then(function (response) {
                $scope.Accounts = response.data;
                $scope.AccLoad = false;
            });

            $scope.SelectedAccounts = [];
            $scope.GlData = [];

            $('#filtermodal').modal('show');
            $scope.IsHideCost = false;

            $scope.SelectedCosts = [];
            $scope.IsSelectAll = false;
            $scope.FileName = "";
        }

        $scope.init();

        $scope.PageName = "Cost Ledger";
        $scope.TokenInfo = AuthenticationService.getTokenInfo();
        if ($scope.TokenInfo == null) {
            $state.go("login");
        } else {
            $scope.checkUserPageAccess($scope.PageName);
        }

        $scope.switchTab = function (data) {
            $scope.SelectedCosts = data;
            $scope.IsSelectAll = false;
            $scope.FileName = "";
        }

        $scope.selectAllCosts = function () {
            if ($scope.IsSelectAll) {
                angular.forEach($scope.SelectedCosts.Childrens, function (e) {
                    e.IsSelected = true;
                })
            } else {
                angular.forEach($scope.SelectedCosts.Childrens, function (e) {
                    e.IsSelected = false;
                })
            }
        }


        $scope.treelistOptions = {
            dataSource: {
                transport: {
                    read: function (o) {
                        MainService.AccountsInKendoTree().then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success([]);
                            toastr.error("NetworkError");
                        })
                    },
                },
                schema: {
                    model: {
                        id: "Id",
                        parentId: "ParentId",
                        fields: {
                            ParentId: {
                                field: "ParentId",
                                nullable: true
                            },
                            Name: {
                                field: "Name",
                                type: "string"
                            },
                            AccountCode: {
                                field: "AccountCode",
                                type: "string"
                            },
                            "AccountType.Name": {
                                //field: "AccountCode",
                                type: "string"
                            }
                        },
                        expanded: true,
                    }
                },
                serverFiltering: false,
            },

            editable: false,
            height: 400,
            sortable: true,
            filterable: {
                mode: "row"
            },
            pageable: {
                pageSize: 50,
                pageSizes: true
            },
            columns: [

                {
                    field: "AccountCode",
                    title: "Account Code",
                },
                {
                    field: "Name",
                    title: "Name",
                },
                {
                    field: "AccountType.Name",
                    title: "Account Type",
                },
                {
                    headerTemplate: "<input  style='margin-left:5px'  type='checkbox' ng-model='selectAllAccRows' ng-click='selectAllAccounts(this)'/>",
                    template: "<input style='margin-left:10px' type='checkbox'  kendo-select={{dataItem.selected}} ng-model='dataItem.checked' ng-change='selectAccountsHead(dataItem)' />",
                    width: "40px"
                },

            ],
        };



        $scope.selectAllAccounts = function (ele) {
            $scope.selectAllAccRows = !$scope.selectAllAccRows;
            if ($scope.selectAllAccRows) {
                angular.forEach($scope.ktl.dataSource.data(), function (row) {
                    row.checked = true;
                })
            } else {
                angular.forEach($scope.ktl.dataSource.data(), function (row) {
                    row.checked = false;
                })
            }
            var grid = $scope.ktl;
            if ($scope.selectAllAccRows) {
                grid.table.find("tr").addClass("k-state-selected");
            } else {
                grid.table.find("tr").removeClass("k-state-selected");
            }
        }


        $scope.selectAccountsHead = function (data) {
            //data.checked = !data.checked;
            var rows = $scope.ktl.dataSource.data();
            var tt = data.checked;
            if (tt) {

                angular.forEach(rows, function (e) {
                    if (e.ParentId == data.Id) {
                        e.checked = true;
                        $scope.selectAccountsHead(e);
                    }
                })

            } else {
                angular.forEach(rows, function (e) {
                    if (e.ParentId == data.Id) {
                        e.checked = false;
                        $scope.selectAccountsHead(e);
                    }
                })
            }

        }

        $scope.searchAcc = function () {

            $scope.ktl.options.dataSource.schema.model.expanded = true;
            $scope.ktl.dataSource.filter({
                field: "Name",
                operator: "contains",
                value: $scope.AccFilter.Keyword
            });
            $scope.ktl.dataSource.read();


        }

        $scope.resetAcc = function () {
            $scope.ktl.dataSource.filter({});
            $scope.ktl.options.dataSource.schema.model.expanded = false;
            $scope.ktl.setDataSource($scope.ktl.options.dataSource);
        }




        $scope.Filter = function () {
            $scope.filter.Accounts = $scope.SelectedAccounts;
            $scope.filter.IsFilter = true;
            $("#gl-master-grid").data("kendoGrid").dataSource.read();
            $('#filtermodal').modal('hide');
        }

        $scope.FilterData = function () {
            $('#filtermodal').modal('show');
        }

        $scope.Reset = function () {
            $scope.init();
            $("#gl-master-grid").data("kendoGrid").dataSource.read();
        }



        $scope.glGridDataSource = new kendo.data.DataSource({
            page: 1,
            pageSize: 100,
            transport: {
                read: function (o) {
                    $scope.totalBalance = "0";
                    if ($scope.filter != null && $scope.filter != undefined) {


                        o.data.IsFilter = $scope.filter.IsFilter;
                        o.data.FromDate = $scope.filter.FromDate;
                        o.data.ToDate = $scope.filter.ToDate;
                        o.data.DocNo = $scope.filter.DocNo;

                        o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                        o.data.FromDay = $scope.filter.FromDate.getDate();
                        o.data.FromYear = $scope.filter.FromDate.getFullYear();

                        o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                        o.data.ToDay = $scope.filter.ToDate.getDate();
                        o.data.ToYear = $scope.filter.ToDate.getFullYear();



                        if ($scope.filter.IsFilter == true) {


                            var accList = $scope.ktl.dataSource.view();

                            var accIds = [];
                            angular.forEach(accList, function (e) {
                                if (e.IsGroup == false && e.checked) {
                                    accIds.push(e.Id);
                                }
                            })

                            console.log(accIds);

                            o.data.Accounts = accIds;

                            var list = [];
                            angular.forEach($scope.CostCenters, function (a) {
                                angular.forEach(a.Childrens, function (e) {
                                    if (e.IsSelected) {
                                        list.push(e.Id)
                                    }
                                })
                            })

                            o.data.CostCenterIds = list;

                            var data = JSON.stringify(o.data);



                            $http.post(config.basePath + "CostGLInView", data).then(function (response) {
                                var data = {
                                    Data: response.data.Data,
                                    Total: response.data.Total,
                                    TotalBalance: response.data.TotalBalance
                                };
                                $scope.GlData = response.data.Data;
                                $scope.totalBalance = kendo.toString(response.data.TotalBalance, '0.00');
                                o.success(data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Some Error Occured");
                            })
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    } else {
                        o.success({
                            Data: []
                        });
                    }
                }
            },
            // change: function (data) {
            //     if (data.items.length > 0) {
            //         data.sender._aggregateResult.BalanceAmount.count = 0;
            //         angular.forEach(data.items, function (a) {
            //             angular.forEach(a.items, function (e) {
            //                 e.aggregates.BalanceAmount.count = Math.abs(e.aggregates.Debit.sum - e.aggregates.Credit.sum);
            //                 e.aggregates.BalanceAmount.count = Math.round(e.aggregates.BalanceAmount.count * 100) / 100;
            //             })
            //             a.aggregates.BalanceAmount.count = Math.abs(a.aggregates.Debit.sum - a.aggregates.Credit.sum);
            //             a.aggregates.BalanceAmount.count = Math.round(a.aggregates.BalanceAmount.count * 100) / 100;
            //         })
            //         data.sender._aggregateResult.BalanceAmount.count = Math.abs(data.sender._aggregateResult.Debit.sum - data.sender._aggregateResult.Credit.sum);
            //         data.sender._aggregateResult.BalanceAmount.count = Math.round(data.sender._aggregateResult.BalanceAmount.count * 100) / 100;
            //     }
            // },
            schema: {
                data: "Data",
                total: "Total",
                model: {
                    id: "Id",
                    fields: {
                        "Account.Name": {
                            type: "string",
                        },
                        AccountId: {
                            type: "number",
                        },
                        Remarks: {
                            type: "string",
                        },
                        PDCType: {
                            type: "string",
                        },
                        Type: {
                            type: "string",
                        },
                        Debit: {
                            type: "number",
                        },
                        Credit: {
                            type: "number",
                        },
                        BalanceAmount: {
                            type: "number",
                            cellFilter: 'number: 2'
                        },
                        Date: {
                            type: "date",
                        },
                        VoucherNumber: {
                            type: "string",
                        },
                        CostCenterName: {
                            type: "string",
                        },
                    },
                }
            },
            group: [
                {
                    field: "CostCenterName",
                    aggregates: [
                        {
                            field: "Debit",
                            aggregate: "sum"
                        },
                        {
                            field: "Credit",
                            aggregate: "sum"
                        }
                    ]
                },
                {
                    field: "PDCType",
                    aggregates: [
                        {
                            field: "Debit",
                            aggregate: "sum"
                        },
                        {
                            field: "Credit",
                            aggregate: "sum"
                        }
                    ]
                }
            ],
            aggregate: [{
                field: "Debit",
                aggregate: "sum"
            },
            {
                field: "Credit",
                aggregate: "sum"
            }],
            serverPaging: false,
            serverSorting: false,
            serverFiltering: false,
        });
        $scope.glGridOptions = {
            stretch: true,
            toolbar: ["excel"],
            excel: {
                allPages: true
            },
            selectable: true,
            editable: false,
            height: 780,
            resizable: true,
            dataSource: $scope.glGridDataSource,
            pageSize: 100,
            pageable: {
                input: false,
                refresh: true,
                pageSizes: true,
                info: true,
            },
            sortable: true,
            scrollable: {
                virtual: true
            },
            filterable: true,
            groupable: false,
            columnMenu: {
                filterable: false,
                filterable: true,
            },
            dataBound: onDataBound,
            columns: [
                {
                    field: "CostCenterName",
                    hidden: true,
                    groupHeaderTemplate: "Cost Center : #= value # ",
                },
                {
                    field: "PDCType",
                    hidden: true,
                    groupHeaderTemplate: " #= value # ",
                },
                {
                    field: "Account.Name",
                    title: "Account",
                },
                {
                    field: "Date",
                    title: "Date",
                    template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                    headerTemplate: "{{LanguageData.date}}",
                },
                {
                    field: "VoucherNumber",
                    title: "Voucher #",
                    headerTemplate: "{{LanguageData.voucher}}",
                },
                {
                    field: "Type",
                    title: "Type",
                    width: "200px",
                    headerTemplate: "{{LanguageData.type}}",
                },
                {
                    field: "Remarks",
                    title: "Remarks",
                    width: "300px",
                    headerTemplate: "{{LanguageData.remarks}}",
                },
                {
                    field: "Debit",
                    title: "Debit",
                    aggregates: ["sum"],
                    template: "<div style='text-align: right'>#=kendo.toString(Debit, 'n')#</div>",
                    groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                    footerTemplate: "<div style='text-align: right'>Debit: #=kendo.toString(sum, 'n')#</div>",
                    headerTemplate: "{{LanguageData.debit}}",
                },
                {
                    field: "Credit",
                    title: "Credit",
                    aggregates: ["sum"],
                    template: "<div style='text-align: right'>#=kendo.toString(Credit, 'n')#</div>",
                    groupFooterTemplate: "#=kendo.toString(sum, 'n')#",
                    footerTemplate: "<div style='text-align: right'>Credit: #=kendo.toString(sum, 'n')#</div>",
                    headerTemplate: "{{LanguageData.credit}}",
                },
                {
                    field: "BalanceAmount",
                    title: "Balance",
                    template: "<div style='text-align: right'>#=kendo.toString(BalanceAmount, 'n')#</div>",
                    //groupFooterTemplate: "Balance: #=kendo.toString(sum, '0.00')#",
                    groupFooterTemplate: function (data) {
                        console.log("groupFooterTemplate", data);
                        var items = [];
                        if (data.field == "CostCenterName") {
                            items = data.items[0] ? data.items[0].items : [];
                        } else {
                            items = data.group ? data.group.items : data.items;
                        }

                        if (items && items.length > 0) {
                            return "Balance: " + kendo.toString(items[items.length - 1].BalanceAmount, '0.00');
                        }
                        return "";
                    },
                    //                                        footerTemplate: "Balance: {{totalBalance}}",
                    footerTemplate: function (data) {
                        console.log("footerTemplate", data);
                        return "Balance: " + $scope.totalBalance;
                    },
                    headerTemplate: "{{LanguageData.balance}}",
                },
            ]
        };

        function customFooter(data) {
            console.log(data);
            return 1;
        }

        function onDataBound() {
            var grid = this;
            grid.element.on('dblclick', 'tbody tr[data-uid]', function (e) {
                grid = $("#gl-master-grid").data("kendoGrid");
                var selectedData = grid.dataItem(grid.select());
                $scope.goLegerVoucher(selectedData);
            })
        }

        $scope.printLedger = function () {

            $scope.filter.IsFilter = $scope.filter.IsFilter;
            $scope.filter.FromDate = $scope.filter.FromDate;
            $scope.filter.ToDate = $scope.filter.ToDate;
            $scope.filter.DocNo = $scope.filter.DocNo;

            $scope.filter.FromMonth = $scope.filter.FromDate.getMonth() + 1;
            $scope.filter.FromDay = $scope.filter.FromDate.getDate();
            $scope.filter.FromYear = $scope.filter.FromDate.getFullYear();

            $scope.filter.ToMonth = $scope.filter.ToDate.getMonth() + 1;
            $scope.filter.ToDay = $scope.filter.ToDate.getDate();
            $scope.filter.ToYear = $scope.filter.ToDate.getFullYear();


            var accList = $.grep($scope.ktl.dataSource.data(), function (e) {
                return e.checked;
            })

            var accIds = [];
            angular.forEach(accList, function (e) {
                if (e.IsGroup == false) {
                    accIds.push(e.Id);
                }
            })

            console.log(accIds);

            $scope.filter.Accounts = accIds;

            $.LoadingOverlay("show", {
                image: "images/load.gif",
            });


            MainService.PrintGeneralLedgerReport($scope.filter).then(function (response) {
                if (response.data != null) {
                    $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                } else {
                    toastr.error("Network Error");
                }
                $scope.Load = false;
                $.LoadingOverlay("hide");
            }, function (err) {
                toastr.error("Network Error");
                $scope.Load = false;
                $.LoadingOverlay("hide");
            })
        }


        //        $scope.GLData = {};
        //        $scope.VoucherData = {};
        //        $scope.GetVoucherDetailsInGL = function () {
        //
        //            $scope.VoucherData = {};
        //
        //            grid = $("#gl-master-grid").data("kendoGrid");
        //            $scope.GLData = grid.dataItem(grid.select());
        //
        //            alert("123");
        //
        //        }

        //        $scope.RecalculateAllAccounts = function () {
        //
        //            $scope.AccLoad = true;
        //            MainService.RecalculateAllAccounts().then(function (response) {
        //                    if (response.data) {
        //                        toastr.success("Success");
        //                    } else {
        //                        toastr.error("Network Error");
        //                    }
        //                    $scope.AccLoad = false;
        //                },
        //                function (err) {
        //                    $scope.AccLoad = false;
        //                    toastr.error("Network Error");
        //                });
        //
        //        }
        //
        //        $scope.RecalculateAccountById = function (data) {
        //            console.log(data)
        //
        //            $scope.AccLoad = true;
        //            MainService.RecalculateAccountById(data.items[0].AccountId).then(function (response) {
        //                    if (response.data) {
        //                        toastr.success("Success");
        //                    } else {
        //                        toastr.error("Network Error");
        //                    }
        //                    $scope.AccLoad = false;
        //                },
        //                function (err) {
        //                    $scope.AccLoad = false;
        //                    toastr.error("Network Error");
        //                });
        //
        //        }

        $scope.goLegerVoucher = function (selectedData) {

            console.log(selectedData)

            if (selectedData.Type == "Sales Invoice") {
                $state.go("editSalesInvoice", {
                    VoucherId: selectedData.SalesInvoiceId
                })
            } else if (selectedData.Type == "Sales Return") {
                $state.go("editSalesReturn", {
                    VoucherId: selectedData.SalesReturnId
                })
            } else if (selectedData.Type == "Purchase Invoice") {
                $state.go("editPurchaseInvoice", {
                    VoucherId: selectedData.PurchaseInvoiceId
                })
            } else if (selectedData.Type == "Purchase Return") {
                $state.go("editPurchaseReturn", {
                    VoucherId: selectedData.PurchaseReturnId
                })
            } else if (selectedData.Type == "Opening Balance") {
                $state.go("editOpeningBalance", {
                    VoucherId: selectedData.OpeningBalanceId
                })
            } else if (selectedData.Type == "Fund Payment Voucher") {
                $state.go("editFPVMaster", {
                    VoucherId: selectedData.FPVId
                })
            } else if (selectedData.Type == "Fund Receipt Voucher") {
                $state.go("editFRVMaster", {
                    VoucherId: selectedData.FRVId
                })
            } else if (selectedData.Type == "Cash Payment Voucher") {
                $state.go("editCPVMaster", {
                    VoucherId: selectedData.CPVId
                })
            } else if (selectedData.Type == "Cash Receipt Voucher") {
                $state.go("editCRVMaster", {
                    VoucherId: selectedData.CRVId
                })
            } else if (selectedData.Type == "Cheque Payment Voucher") {
                $state.go("editChequePVMaster", {
                    VoucherId: selectedData.ChequePaymentId
                })
            } else if (selectedData.Type == "Cheque Receipt Voucher") {
                $state.go("editChequeRVMaster", {
                    VoucherId: selectedData.ChequeReceiptId
                })
            } else if (selectedData.Type == "Journal Voucher") {
                $state.go("editJVMaster", {
                    VoucherId: selectedData.JVId
                })
            } else if (selectedData.Type == "PDC") {
                //                $state.go("editPurchaseInvoice", {
                //                    VoucherId: selectedData.PDCId
                //                })
            } else if (selectedData.Type == "Company Expense") {
                $state.go("editcompanyExpense", {
                    VoucherId: selectedData.CompanyExpenseId
                })
            } else if (selectedData.Type == "Counter Sales") {
                //                $state.go("editPurchaseInvoice", {
                //                    VoucherId: selectedData.
                //                })
            }
            //            if (selectedData.Type == "Contract Invoice") {
            //                $state.go("editPurchaseInvoice", {
            //                    VoucherId: selectedData.
            //                })
            //            }
            else if (selectedData.Type == "Direct Sales Invoice") {
                $state.go("editDirSalesInvoice", {
                    VoucherId: selectedData.DirSalesInvoiceId
                })
            } else if (selectedData.Type == "Direct Purchase Invoice") {
                $state.go("editDirPurchaseInvoice", {
                    VoucherId: selectedData.DirPurchaseInvoiceId
                })
            } else if (selectedData.Type == "Export Sales Invoice") {
                $state.go("editExpSalesInvoice", {
                    VoucherId: selectedData.ExpSalesInvoiceId
                })
            } else if (selectedData.Type == "Export Purchase Invoice") {
                $state.go("editExpPurchaseInvoice", {
                    VoucherId: selectedData.ExpPurchaseInvoiceId
                })
            } else if (selectedData.Type == "Import Purchase Invoice") {
                $state.go("editImpPurchaseInvoice", {
                    VoucherId: selectedData.ImpPurchaseInvoiceId
                })
            } else if (selectedData.Type == "Opening Stock") {
                $state.go("editOpeningStock", {
                    VoucherId: selectedData.OpeningStockId
                })
            } else if (selectedData.Type == "Stock Issue") {
                $state.go("editStockIssue", {
                    VoucherId: selectedData.StockIssueId
                })
            } else if (selectedData.Type == "Stock FOC") {
                $state.go("editStockFOC", {
                    VoucherId: selectedData.StockFOCId
                })
            } else if (selectedData.Type == "Stock Receive") {
                $state.go("editStockRecieve", {
                    VoucherId: selectedData.StockReceiveId
                })
            } else if (selectedData.Type == "Credit Note") {
                $state.go("editCreditNote", {
                    VoucherId: selectedData.CreditNoteId
                })
            } else if (selectedData.Type == "Debit Note") {
                $state.go("editDebitNote", {
                    VoucherId: selectedData.DebitNoteId
                })
            } else if (selectedData.Type == "Individual Sales Invoice") {
                $state.go("editIndSalesInvoice", {
                    VoucherId: selectedData.IndSalesInvoiceId
                })
            } else if (selectedData.Type == "Individual Purchase Invoice") {
                $state.go("editIndPurchaseInvoice", {
                    VoucherId: selectedData.IndPurchaseInvoiceId
                })
            }
        }



    }]);
